<template>
  <div>
    <PCMenu :memberSystem="company"/>
    <div class="m-auto main m-t-10">
      <!--富士伟业 -->
      <div v-if="company&&company.memberSystemId==116" class="w1200 m-auto flex m-b-50">
        <div>
          <img src="@/assets/images/product-116.jpg" style="width:300px;height:400px;margin-left:15px;">
        </div>
        <div class="buy m-l-20  fswy">
          <p style="font-weight: 700;color:#FF9900;font-size:30px;">订购及续费：</p>
          <p style="font-size:20px;padding:10px 0;">成为富士伟业汽车维修资料库VIP会员。</p>
          <p style="margin-top:50px;"><b>订购或续费时长：</b>一年</p>
          <p><b>原价：<span style="color:red">590元</span></b>（非富士伟业诊断仪用户）</p>
          <p><strong>VIP会员价：<span style="color:red">{{ product.price }}元</span></strong></p>
          <p>
            <strong>订购支持：</strong>
            <span>购买富士伟业诊断仪并进行微信分享，可免费获取一年使用权。</span>
          </p>
          <div @click="onSubmit(product.id)" class="buybutton" style="background: #FF9900;">立即订购或续费</div>
        </div>
      </div>
      <div v-else class="w1200 m-auto flex m-b-50  m-t-10">
        <div>
          <img src="@/assets/images/product.jpg">
        </div>
        <div class="buy m-1l-100" style="align-items: center;display: flex;flex-direction: column">
          <h3>{{ product.productName }}
            <!-- <span>（缴费后自动开通）</span> -->
          </h3>
          <div class="buyinfo m-t-30 p-t-50">
            <ul class="flex">
              <li>价格</li>
              <li style="text-decoration:line-through;">￥688.00</li>
            </ul>
            <ul class="flex" style="align-items: center">
              <li>促销价</li>
              <li class="price">￥{{ product.price }}</li>
            </ul>
            <!--            <ul class="flex">-->
            <!--              <li>活动赠送</li>-->
            <!--              <li class="huodong">10积分，积分可以用于查看案例</li>-->
            <!--            </ul>-->
          </div>
          <div @click="onSubmit(product.id)" class="buybutton">立即购买</div>
        </div>
      </div>
      <!-- <div class="line m-auto"></div>
      <div class="flex">
        <div class="qrcode m-t-30">
          <img src="@/assets/images/QRCode.png">
          <div>微信扫一扫，加客服微信</div>
        </div>
        <div class="contactus">
          <h3>港澳臺地區會員充值，請聯系客服</h3>
          <p>
            客服微訊 ： daida-sh<br>
            客服專線： +86-21-38755683
          </p>
          <div class="line1 m-t-20 m-b-20"></div>
          <p style="color:#666666;">
            若無法使用微信或支付寶完成線上付款，請進入淘寶網拍下付費，網址如下<br>
            <a style="color:#275196;" href="#">https://item.taobao.com/item.htm?id=574267939477</a><br>
            付費後請加入上海軑達客服微信 或 聯繫客服專線，並告知單號，客服會在10分鐘內開通<br>
          </p>
        </div>
      </div> -->
    </div>
    <!--    <PCCopyright />-->
    <van-popup closeable close-icon="close" v-model="show" :style="{width:'30%', height: '50%' }">
      <van-row style="background:#CCC; height:50px; line-height:50px;">
        <van-col span="24">确认订单</van-col>
      </van-row>
      <van-row style="height:50px; line-height:50px; text-align:left; padding-left:20px">
        <van-col span="20">{{ product.productName }}</van-col>
        <van-col span="4">￥{{ product.price }}</van-col>
      </van-row>
      <van-cell-group>
        <van-radio-group v-model="payType">
          <van-cell size="large" title-style="text-align:left;" class="f-16 p-10" clickable @click="payType = '微信'">
            <template #title>
              <span class="custom-title f-16 m-l-20">微信支付</span>
            </template>
            <template #icon="">
              <van-icon class="iconfont m-10" class-prefix="icon" name="weixinzhifu" size="36px" color="#40ba49"/>
            </template>
            <template #right-icon>
              <van-radio name="微信"  style="padding-right:50px;" checked-color="green"/>
            </template>
          </van-cell>
          <!-- <van-cell size="large" title-style="text-align:left;" class="f-16" clickable @click="payType = '5'">
            <template #title>
              <span class="custom-title f-16 m-l-20">微信支付</span>
            </template>
            <template #icon>
              <van-icon class="iconfont m-10" class-prefix="icon" name="zhifubao" size="36px" color="#009fe8" />
            </template>
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell> -->
        </van-radio-group>
      </van-cell-group>
      <van-submit-bar :price="product.price*100" button-text="提交订单" @submit="callpay"/>
    </van-popup>
  </div>
</template>

<script>
import PCMenu from "@/components/PCMenu.vue";
import PCCopyright from "@/components/PCCopyright.vue";
import {Get_Product_List, NativeByCodeUrl, Add_Order} from "@/api/index";
import {
  Col,
  Row,
  Icon,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  Popup,
  SubmitBar,
  Dialog,
} from "vant";

export default {
  name: "Product",
  components: {
    PCMenu,
    PCCopyright,
    [Col.name]: Col,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [SubmitBar.name]: SubmitBar,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      user: this.global.getUserInfo(),
      company: {},
      payType: "微信",
      show: false,
      product: {},
      payChecked:true,
      payParams: {},
    };
  },
  methods: {
    onSubmit: function (productId) {
      this.show = true;
    },
    async callpay() {
      Add_Order({
        productId: this.product.id,
        payType: this.payType,
      }).then((orderSn) => {
        sessionStorage.setItem(
            "OrderData",
            JSON.stringify({
              pId: this.product.id,
              no: orderSn,
              price: this.product.price,
            })
        );
        this.$router.push({
          path: "/pc/wxpay/" + this.product.id + "/" + orderSn,
        });
      });
    },
  },
  mounted() {
    this.global.getMemberSystem().then((company) => {
      this.company = company;
      if (company.isCanPay == 0) {
        Dialog.alert({
          message: "请联系客服",
        }).then(() => {
          this.$router.push({path: "/"});
        });
      }
    });
    Get_Product_List({notShowToast:true}).then((data) => {
      this.product = data || {};
    });
  },
};
</script>
<style lang="css" scoped>
.fswy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 30px;
  zoom: 0.8;
}

.fswy p {
  font-size: 22px;
  padding: 5px 0;
}
</style>
